@if (imageUrl) {
  <div>
    <img [src]="imageUrl" class="img-fluid img-thumbnail" [alt]="getFileName(fileUrl)" />
  </div>
}
@if (!imageUrl) {
  <div>
    <p>Loading...</p>
  </div>
}
